// eslint-disable-next-line
// @ts-ignore
import('./containers/App/App')
